import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private activeRequests = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  show(): void {
    this.activeRequests++;
    this.updateLoadingState();
  }

  hide(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    this.updateLoadingState();
  }

  private updateLoadingState(): void {
    this.loadingSubject.next(this.activeRequests > 0);
  }
}
